import styled from 'styled-components';

interface IBadgeExpProps {
  background?: string;
  color?: string;
  style?: React.CSSProperties;
}

export const Container = styled.section<IBadgeExpProps>`

> span {
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => props.theme.cards.primary};
    border: 1px solid ${props => props.theme.cards.border};
    padding: 6px 12px;
    border-radius: 16px;
    font-size: 11px;
    flex-flow: wrap;

    > img {
      width: 23px;
      margin-right: 8px;
    }
  }
`;
